import _ from 'lodash';
import React from 'react';
import AlertContainer from 'react-alert';

const alertOptions = {
	offset: 14,
	position: 'bottom right',
	theme: 'light',
	time: 5000,
	transition: 'scale'
};

export class Alert extends React.Component {
	show = (meta) => {
		const code = _.get(meta, 'code', 500);
		const message = _.get(meta, 'message', '');

		if (code === 200 || code === 201) {
			this.msg.success(message);
		} else {
			this.msg.error(message);
		}
	}

	render () {
		return (
			<AlertContainer ref={a => this.msg = a} {...alertOptions}/>
		);
	}
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alert/index.js